module.exports = __webpack_public_path__ + "fonts/iconfont.39cad5f.woff2";